<article class="mt-5 panel" [formGroup]="reportForm">
  <p class="panel-heading has-text-white" translate="captureTransaction.detailCheck"></p>
  <div class="panel-block is-flex-direction-column">
    <div class="is-fullwidth mb-2">
      <fino-select
        [items]="reportPresetItems"
        formControlName="preset"
        label="preset"
        bindLabel="label"
        bindValue="value"
      >
        <div *select-item="let item">
          <div>{{ item.value | translate }}</div>
        </div>
      </fino-select>
    </div>

    <p translate="captureTransaction.reportDescription"></p>
    <div class="mt-2 is-fullwidth">
      <fino-textarea formControlName="comment" label="comment"> </fino-textarea>
    </div>
    <div class="mt-2 is-justify-content-flex-start is-fullwidth">
      <button
        [loading]="reportDocumentLoading()"
        fino-button
        (click)="reportDocument()"
        aria-label="Report document"
      >
        <label class="mr-1" translate="captureTransaction.report"></label>
      </button>
    </div>
  </div>
</article>
